import { buildPath, OpaqueUrl } from '../../../routing/util';
import { withoutUndefinedValues } from '../../../util/withoutUndefinedValues';
import { FilterChoice } from '../types/FilterChoice';
import { makeWholePath } from './path-segments/wholePath';
import { makeQueryParams } from './queryParams';

export const makeSearchUrl = (filters: FilterChoice): OpaqueUrl => {
  const path = [...makeWholePath(filters)];
  const queryParams = makeQueryParams(filters);
  return { pathname: buildPath(...path), query: withoutUndefinedValues(queryParams) };
};
